export const ICON_TYPES = {
  externalLink: 'external-link',
};
